'use client';

import { isServer } from '@tanstack/react-query';
import { XIcon } from 'lucide-react';

export const siteNoticeLocalStorageKey = 'site-notice-closed';

export function SiteNotice({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  return !isOpen ? null : (
    <div className="relative flex h-[2rem] w-full items-center justify-center bg-red text-white">
      <p className="title text-sm">
        We just launched!{' '}
        <a href="mailto:dev@baseballnearyou.com" className="underline">
          Share your feedback.
        </a>
      </p>
      <button
        className="absolute right-5 size-4"
        onClick={() => {
          setIsOpen(false);
          if (!isServer) {
            localStorage.setItem(siteNoticeLocalStorageKey, '1');
          }
        }}
        type="button"
      >
        <XIcon size={14} />
      </button>
    </div>
  );
}
